import React, { createContext, useCallback, useEffect, useState } from 'react';
import { LocationService } from '../service/locationService';
import { useAuth } from '../hooks/useAuth';

const LocationContext = createContext(null);

export const LocationProvider = ({ children }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [availableLocations, setAvailableLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  // Fetch all locations on mount
  useEffect(() => {
    const loadLocations = async () => {
      setLoading(true);
      try {
        const res = await LocationService.getLocations();
        if (res.code === 0 && res.data) {
          setAvailableLocations(res.data);

          // Auto-select location based on localStorage or first location
          const savedLocationId = localStorage.getItem('selectedLocationId');
          if (savedLocationId) {
            const saved = res.data.find(loc => String(loc.id) === String(savedLocationId));
            if (saved) {
              setSelectedLocation(saved);
            } else {
              // Saved location no longer exists, select first
              if (res.data.length > 0) {
                setSelectedLocation(res.data[0]);
                localStorage.setItem('selectedLocationId', res.data[0].id);
              }
            }
          } else {
            // No saved location, select first
            if (res.data.length > 0) {
              setSelectedLocation(res.data[0]);
              localStorage.setItem('selectedLocationId', res.data[0].id);
            }
          }
        }
      } catch (error) {
        console.error('Failed to load locations:', error);
        setAvailableLocations([]);
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      loadLocations();
    }
  }, [user]);

  const switchLocation = useCallback((locationId) => {
    const location = availableLocations.find(loc => String(loc.id) === String(locationId));
    if (location) {
      setSelectedLocation(location);
      localStorage.setItem('selectedLocationId', location.id);
    }
  }, [availableLocations]);

  const value = {
    selectedLocation,
    availableLocations,
    loading,
    switchLocation
  };

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};

export default LocationContext;
